import React, {Component} from 'react';
import {accountService} from "./Account.service";
export default class SideBarAdmin extends Component {

    setRedirection(rootpath){
        window.location.replace(rootpath);
    }

    render(){
        accountService.isLoggedRedirect();

        if (accountService.isLogged()){
            return (
                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle text-danger" href="http://localhost:8080" role="button" data-bs-toggle="dropdown"
                       aria-expanded="false">Admin</a>
                    <ul className="dropdown-menu">
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/stats')}>Stats</button></li>
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/curriculums')}>Curriculums</button></li>
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/blogs')}>Blogs</button></li>
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/careers')}>Careers</button></li>
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/education')}>Education</button></li>
                        <li><hr className="dropdown-divider"></hr></li>
                        <li><button className="dropdown-item" onClick={() => this.setRedirection('/admin/logout')}>Logout</button></li>

                    </ul>
                </li>

            );
        }

    }
}